import { createAction } from '@reduxjs/toolkit';

import type { UpdateMcpConfigPayload } from '@polyai/schemas';

const PREFIX = 'mcpConfig';

export const updateMcpConfig = createAction<UpdateMcpConfigPayload>(
  `${PREFIX}/updateConfig`,
);
